import { el, clear, debounce } from '../../utils/dom.js';
import { Maintenance } from '../../api/resources.js';
import { dataTable } from '../../components/table.js';
import { statusBadge } from '../../components/badge.js';
import { fmtDateTime, fmtMoney } from '../../utils/format.js';

const STATUSES = ['', 'pendiente','en_proceso','completado','cancelado'];
const TYPES = ['', 'preventivo','correctivo','limpieza','revision','reparacion','calibracion','cambio_pieza'];

export default async function MaintenanceListPage(outlet) {
  clear(outlet);
  const state = { page: 1, q: '', status: '', type: '' };

  outlet.appendChild(el('div', { class: 'page-head' },
    el('h1', {}, 'Mantenimiento'),
    el('a', { href: '#/maintenance/new', class: 'btn primary' }, '+ Nuevo'),
  ));

  const search = el('input', { class: 'input grow', placeholder: 'Buscar...',
    oninput: debounce((e) => { state.q = e.target.value; state.page = 1; refresh(); }, 300) });
  const statusSel = el('select', { class: 'select', onchange: (e) => { state.status = e.target.value; state.page = 1; refresh(); } },
    ...STATUSES.map((s) => el('option', { value: s }, s || 'Todo estado')));
  const typeSel = el('select', { class: 'select', onchange: (e) => { state.type = e.target.value; state.page = 1; refresh(); } },
    ...TYPES.map((t) => el('option', { value: t }, t || 'Todo tipo')));
  outlet.appendChild(el('div', { class: 'toolbar' }, search, statusSel, typeSel));

  const host = el('div');
  outlet.appendChild(host);

  async function refresh() {
    host.innerHTML = '<div class="empty">Cargando...</div>';
    try {
      const res = await Maintenance.list({
        page: state.page, limit: 25,
        q: state.q || undefined, status: state.status || undefined, type: state.type || undefined,
      });
      host.replaceChildren(dataTable({
        columns: [
          { key: 'code', label: 'Codigo', render: (r) => el('a', { href: `#/maintenance/${r.id}`, class: 'text-mono text-bold' }, r.code) },
          { key: 'item_name', label: 'Equipo', render: (r) => el('div', {}, r.item_name || '—', r.serial_number ? el('div', { class: 'text-xs muted text-mono' }, r.serial_number) : null) },
          { key: 'type',  label: 'Tipo' },
          { key: 'status', label: 'Estado', render: (r) => statusBadge(r.status) },
          { key: 'technician', label: 'Tecnico', render: (r) => r.technician || '—' },
          { key: 'cost', label: 'Costo', className: 'right', render: (r) => fmtMoney(r.cost) },
          { key: 'start_date', label: 'Inicio', render: (r) => r.start_date ? fmtDateTime(r.start_date) : '—' },
          { key: 'end_date',   label: 'Fin',    render: (r) => r.end_date ? fmtDateTime(r.end_date) : '—' },
        ],
        rows: res.data || [],
        empty: 'Sin registros.',
        pagination: res.pagination ? { page: res.pagination.page, pages: res.pagination.pages, onPage: (p) => { state.page = p; refresh(); } } : null,
      }));
    } catch (ex) {
      host.innerHTML = `<div class="empty">Error: ${ex.message}</div>`;
    }
  }
  refresh();
}
